import { login, getProfile } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = { token: getToken(), profile: null }

const mutations = {
  SET_TOKEN(state, token) { state.token = token },
  SET_PROFILE(state, profile) { state.profile = profile }
}

const actions = {
  async login({ commit }, form) {
    const result = await login(form)
    setToken(result.access_token)
    commit('SET_TOKEN', result.access_token)
  },
  async getProfile({ commit }) {
    const profile = await getProfile()
    commit('SET_PROFILE', profile)
    return profile
  },
  logout({ commit }) {
    removeToken()
    commit('SET_TOKEN', '')
    commit('SET_PROFILE', null)
  }
}

export default { namespaced: true, state, mutations, actions }

